<template>
  <el-form :model="form">
    <el-form-item :label="$t('powerBiCapacityName')">
      <el-select
        v-model="form.powerBiCapacityName"
        size="small"
        :placeholder="$t('empty')"
        @change="handleChangePowerBiCapacityName"
      >
        <el-option
          v-for="item in powerBiCapacityNames"
          :key="item"
          :label="item"
          :value="item"
        ></el-option>
      </el-select>
    </el-form-item>
  </el-form>
</template>
<script lang="ts">
import { ElForm, ElFormItem, ElOption, ElSelect } from 'element-plus';
import { PowerBiWorkspaceConfiguration } from '@/views/admin/tenants/models/TenantAzureConfigurationObjects';
import { onMounted, onUpdated, ref } from 'vue';

export default {
  name: 'PowerBiWorkspaceConfigurationForm',
  components: { ElForm, ElFormItem, ElOption, ElSelect },
  props: {
    configuration: { type: String, default: '' },
    powerBiCapacityNames: {
      type: Array as () => Array<string>,
      default: () => new Array<string>()
    }
  },
  emits: ['update-configuration'],
  setup(props, { emit }) {
    let form = ref(new PowerBiWorkspaceConfiguration());
    let localConfugrationObject = ref({});

    const emitUpdateEvent = () => {
      emit(
        'update-configuration',
        JSON.stringify({
          ...localConfugrationObject.value,
          ...form.value
        })
      );
    };

    const handleChangePowerBiCapacityName = (newValue: string) => {
      form.value.powerBiCapacityName = newValue;
      emitUpdateEvent();
    };

    const updateLocalVars = () => {
      localConfugrationObject.value = JSON.parse(props.configuration || '{}');
      form.value.powerBiCapacityName =
        localConfugrationObject.value['powerBiCapacityName'] ?? '';
    };

    onMounted(() => {
      updateLocalVars();
      emitUpdateEvent();
    });
    onUpdated(() => updateLocalVars());

    return {
      form,
      handleChangePowerBiCapacityName
    };
  }
};
</script>
<style scoped lang="scss"></style>
